import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { validatePromoCode } from "@services/paymentService";

// Get coupon from search param
const useProcessCoupon = () => {
    const [searchParams] = useSearchParams();
    const coupon = searchParams.get("coupon");

    useEffect(() => {
        async function processCoupon() {
            if (coupon) {
                const result = await validatePromoCode(coupon);
                if (result.isValid) {
                    localStorage.setItem("coupon", coupon);
                    console.log("Promo code is valid");
                } else {
                    console.log("Promo code is invalid or expired.");
                }
            }
        }
        void processCoupon();
    }, [coupon]);
};

export default useProcessCoupon;
